var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticClass:"footer",attrs:{"app":""}},[_c('div',{staticClass:"footer"},[_vm._v(" @ "),_c('a',{attrs:{"target":"_blank","href":"https://ericssongomes.com"}},[_c('span',[_vm._v("Ericsson Gomes")])]),_vm._v(". Pokedex © "+_vm._s(new Date().getFullYear()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }